// extracted by mini-css-extract-plugin
export default {"DemoSection":"DemoSection_DemoSection__XoAS-","DemoSection__VideoContainer":"DemoSection_DemoSection__VideoContainer__yhliF"};